export default __webpack_public_path__ + "static/media/card-blog18.2e72d78e.jpg";